<app-title-bar rootBreadCrumbs="['i18n.core.navigation.admin']" titleText="i18n.domain.parking-ranger-assignment-administration.title"></app-title-bar>
<div class="row align-items-center">
  <div class="col-12">
    <div class="d-flex align-items-center mb-2">
      <app-search-field (searchTextChanged)="onSearchTextChanged($event)"></app-search-field>
    </div>
  </div>
</div>
<div class="control-section">
  <ejs-grid #grid
            class="grid-with-toolbar grid-with-footer"
            width="100%"
            rowHeight="38"
            [dataSource]="data"
            [allowSorting]="true"
            [filterSettings]="filterSettings"
            [allowFiltering]="true"
            [allowPaging]="true"
            [pageSettings]="pageSettings"
            [allowResizing]="true"
            [editSettings]="editSettings"
            [searchSettings]="searchOptions"
            [showColumnChooser]='true'
            [toolbar]='toolbar'
            (commandClick)="commandClicked($event)"
            (recordDoubleClick)="onRecordDoubleClick($event)"
            (actionBegin)="actionBegin($event)"
            (actionComplete)="actionComplete($event)">
    <ng-template #toolbarTemplate
                 let-data>
      <ejs-toolbar>
        <e-items>
          <e-item [text]="'i18n.domain.parking-ranger-assignment-administration.overview.add' | translate"
                  prefixIcon="e-icons icon-add"
                  (click)="onAdd()"></e-item>
          <e-item [text]="'i18n.domain.parking-ranger-assignment-administration.overview.bulkDelete' | translate"
                  prefixIcon="e-icons icon-trash-can"
                  (click)="onBulkDelete()"></e-item>
        </e-items>
      </ejs-toolbar>
    </ng-template>
    <e-columns>
      <e-column field="id"
                [visible]="false"
                [isPrimaryKey]="true"
                [showInColumnChooser]="false"></e-column>
      <e-column field="user.userName"
                type="string"
                headerText="{{'i18n.domain.parking-ranger-assignment-administration.grid.userName' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="zone.name"
                type="string"
                headerText="{{'i18n.domain.parking-ranger-assignment-administration.grid.zoneName' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="{{zonePathFieldName}}"
                [allowFiltering]="false"
                [allowSorting]="false"
                type="string"
                headerText="{{'i18n.domain.parking-ranger-assignment-administration.grid.zonePath' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="client.name"
                type="string"
                headerText="{{'i18n.domain.parking-ranger-assignment-administration.grid.zoneClientName' | translate}}"
                clipMode="EllipsisWithTooltip">
      </e-column>
      <e-column field="isRegistrationCreationEnabled"
                headerText="{{'i18n.domain.parking-ranger-assignment-administration.dialog.isRegistrationCreationEnabled' | translate}}"
                clipMode="EllipsisWithTooltip" width="150">
        <ng-template #template let-data>
          <span class="e-icons" [class.icon-checkmark]="data.isRegistrationCreationEnabled"></span>
        </ng-template>
      </e-column>
      <e-column field="isSessionCreationEnabled"
                headerText="{{'i18n.domain.parking-ranger-assignment-administration.dialog.isSessionCreationEnabled' | translate}}"
                clipMode="EllipsisWithTooltip" width="150">
        <ng-template #template let-data>
          <span class="e-icons" [class.icon-checkmark]="data.isSessionCreationEnabled"></span>
        </ng-template>
      </e-column>
      <e-column field="isCurrentPositionEnabled"
                headerText="{{'i18n.domain.parking-ranger-assignment-administration.dialog.isCurrentPositionEnabled' | translate}}"
                clipMode="EllipsisWithTooltip" width="150">
        <ng-template #template let-data>
          <span class="e-icons" [class.icon-checkmark]="data.isCurrentPositionEnabled"></span>
        </ng-template>
      </e-column>
      <e-column field="isPositionTrackingEnabled"
                headerText="{{'i18n.domain.parking-ranger-assignment-administration.dialog.isPositionTrackingEnabled' | translate}}"
                clipMode="EllipsisWithTooltip" width="150">
        <ng-template #template let-data>
          <span class="e-icons" [class.icon-checkmark]="data.isPositionTrackingEnabled"></span>
        </ng-template>
      </e-column>
      <e-column field="newSessionCreationAfterHours"
                type="number"
                headerText="{{'i18n.domain.parking-ranger-assignment-administration.dialog.newSessionCreationAfterHours' | translate}}"
                clipMode="EllipsisWithTooltip" width="150">
      </e-column>
      <e-column field="previewConsideredHours"
                type="number"
                headerText="{{'i18n.domain.parking-ranger-assignment-administration.dialog.previewConsideredHours' | translate}}"
                clipMode="EllipsisWithTooltip" width="150">
      </e-column>
      <e-column headerText=""
                [commands]="gridCommands" width="145px"
                [showInColumnChooser]="false"></e-column>
    </e-columns>
  </ejs-grid>
</div>
<app-parking-ranger-assignment-edit-dialog (refreshData)="onRefreshData()"></app-parking-ranger-assignment-edit-dialog>
